import { render } from "./EditingMediaTvSeries.vue?vue&type=template&id=68b7b453"
import script from "./EditingMediaTvSeries.vue?vue&type=script&lang=js"
export * from "./EditingMediaTvSeries.vue?vue&type=script&lang=js"
script.render = render

export default script